module.exports = __webpack_public_path__ + "media/toneC2.2a432e87.mp3";